import { Post } from "@pulsex/types";
import { convert } from "html-to-text";
class PostModel {
    constructor(config) {
        this.config = config;
        if (!config.MEDIA_URL || !config.CLIENT_URL) {
            throw new Error('Invalid config: MEDIA_URL and CLIENT_URL are required');
        }
    }
    extractTextContent(content) {
        if (!content)
            return "";
        return convert(content, {
            wordwrap: false,
            whitespaceCharacters: " ",
            selectors: [
                { selector: "p", format: "inline" },
                { selector: "*", format: "skip" },
            ],
        });
    }
    mapMedias(medias) {
        if (!medias)
            return [];
        return medias.map((media) => {
            var _a, _b, _c, _d;
            const provider = media === null || media === void 0 ? void 0 : media.provider;
            const isPDF = (_a = media === null || media === void 0 ? void 0 : media.url) === null || _a === void 0 ? void 0 : _a.endsWith(".pdf");
            return {
                type: (_b = media === null || media === void 0 ? void 0 : media.type) !== null && _b !== void 0 ? _b : '',
                url: (media === null || media === void 0 ? void 0 : media.url)
                    ? provider === "mangopulse" && !isPDF
                        ? `${this.config.MEDIA_URL}/${media.url}`
                        : media.url
                    : "",
                provider: provider !== null && provider !== void 0 ? provider : '',
                embedUrl: (_c = media === null || media === void 0 ? void 0 : media.embedUrl) !== null && _c !== void 0 ? _c : '',
                placement: (_d = media === null || media === void 0 ? void 0 : media.placement) !== null && _d !== void 0 ? _d : '',
            };
        });
    }
    mapAuthor(author) {
        var _a, _b, _c, _d;
        if (!author)
            return null;
        if (typeof author === 'string') {
            return {
                name: author,
                icon: '',
                summary: '',
                id: '',
            };
        }
        return {
            name: (_a = author.name) !== null && _a !== void 0 ? _a : '',
            icon: (_b = author.icon) !== null && _b !== void 0 ? _b : '',
            summary: (_c = author.summary) !== null && _c !== void 0 ? _c : '',
            id: (_d = author.id) !== null && _d !== void 0 ? _d : '',
        };
    }
    mapTag(tag) {
        var _a, _b, _c;
        if (!tag)
            return null;
        if (typeof tag === 'string') {
            return {
                title: tag,
                url: '',
                color: '',
            };
        }
        return {
            title: (_a = tag.title) !== null && _a !== void 0 ? _a : '',
            url: (_b = tag.url) !== null && _b !== void 0 ? _b : '',
            color: (_c = tag.color) !== null && _c !== void 0 ? _c : '',
        };
    }
    mapMetas(metas) {
        if (!metas)
            return [];
        return metas.map(meta => {
            var _a, _b, _c;
            return ({
                title: (_a = meta.title) !== null && _a !== void 0 ? _a : '',
                value: (_b = meta.value) !== null && _b !== void 0 ? _b : '',
                key: (_c = meta.key) !== null && _c !== void 0 ? _c : '',
            });
        });
    }
    mapRelatives(relatives) {
        if (!relatives)
            return [];
        return relatives.map(rel => {
            var _a, _b, _c;
            return ({
                relationName: (_a = rel.relationName) !== null && _a !== void 0 ? _a : '',
                direction: (_b = rel.direction) !== null && _b !== void 0 ? _b : '',
                posts: (_c = rel.posts) !== null && _c !== void 0 ? _c : [],
            });
        });
    }
    mapThumbnail(thumbnail) {
        if (!thumbnail)
            return null;
        // replaceing alpha urls coming from elasticsearch
        if (thumbnail.startsWith("http")) {
            return thumbnail.replace("https://alpha-en-media.almayadeen.net", this.config.MEDIA_URL);
        }
        return thumbnail ? `${this.config.MEDIA_URL}/${thumbnail.trim()}` : null;
    }
    mapPost(rawPost) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        if (!rawPost)
            return undefined;
        const metas = this.mapMetas(rawPost.metas);
        const medias = this.mapMedias(rawPost.medias);
        return new Post((_a = rawPost.id) !== null && _a !== void 0 ? _a : '', (_b = rawPost.title) !== null && _b !== void 0 ? _b : '', (_c = rawPost.publicUrl) !== null && _c !== void 0 ? _c : '', rawPost.publicUrl ? `${this.config.CLIENT_URL}${rawPost.publicUrl}` : null, (_d = rawPost.content) !== null && _d !== void 0 ? _d : '', rawPost.url, (_e = rawPost.summary) !== null && _e !== void 0 ? _e : '', rawPost.shares, rawPost.views, (_f = rawPost.terms) !== null && _f !== void 0 ? _f : [], (_g = rawPost.country) !== null && _g !== void 0 ? _g : '', medias, (_h = rawPost.keywords) !== null && _h !== void 0 ? _h : [], rawPost.isLive, this.mapTag(rawPost.tag || rawPost.category), (_j = rawPost.postType) !== null && _j !== void 0 ? _j : '', this.extractTextContent(rawPost.content), (_l = ((_k = rawPost.imageCaption) !== null && _k !== void 0 ? _k : rawPost.thumbnailCaption)) !== null && _l !== void 0 ? _l : '', (_m = rawPost.thumbnailSource) !== null && _m !== void 0 ? _m : '', (_o = rawPost.displayDate) !== null && _o !== void 0 ? _o : '', (_p = rawPost.publishDate) !== null && _p !== void 0 ? _p : '', this.mapThumbnail(rawPost.thumbnail), this.mapAuthor(rawPost.author), (_q = rawPost.date) !== null && _q !== void 0 ? _q : null, metas, this.mapRelatives(rawPost.relatives), (_r = rawPost.relativesCount) !== null && _r !== void 0 ? _r : 0, (_s = rawPost.readingTimeInMinutes) !== null && _s !== void 0 ? _s : 0, rawPost.disclaimer, (_t = rawPost === null || rawPost === void 0 ? void 0 : rawPost.isVideo) !== null && _t !== void 0 ? _t : false);
    }
}
export default PostModel;
